import axios from "../../js/project-axios.js"

const list = (endTime, limit) => {
    return axios.get("/tradeDay/list", {
        params: {
            endTime,
            limit
        }
    });
};

export default {
    list
};